import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import BasicNav from './BasicNav';

interface LayoutProps {
  children?: React.ReactNode;
  showUnauthenticatedNav?: boolean;
}

const SignInLink: FC = () => {
  return (
    <div className="flex items-center justify-end flex-grow pr-8">
      <Link className="text-blue-80 text-lg font-effra hover:no-underline" to="/login">
        Sign in
      </Link>
    </div>
  );
};

const BasicLayout = ({ children, showUnauthenticatedNav }: React.PropsWithChildren<LayoutProps>) => {
  const currentYear: number = new Date().getFullYear();
  return (
    <div className="flex flex-col h-screen min-h-0 bg-grey">
      {showUnauthenticatedNav && <BasicNav menu={<SignInLink />} logoPath="/login" />}
      <main id="content" className="flex flex-col flex-1">
        {children}
      </main>
      <footer className="p-3 text-center font-effra">Teladoc Health ©{currentYear} Created by Teladoc Health</footer>
    </div>
  );
};

export default BasicLayout;
